import React from 'react'
import { jumpBack$ } from '@zambezi/caballo-vivo'

export default function NotFoundError({ brand }) {
  return (
    <div className="ob-error">
      <h1 className="zb-heading2">
        We're sorry, we cannot find what you're looking for
      </h1>
      <div className="zb-card">
        <div className="zb-card-body">
          You may have followed an invalid link or the page you are looking for
          expired and is no longer available.
          <br />
          If you believe this to be an error, you can contact our{' '}
          <a
            href={brand.getIn(['links', 'support'])}
            target="_blank"
            rel="noopener noreferrer"
          >
            {brand.get('name')} support centre
          </a>
          .
          <br />
          <br />
          You can <a onClick={() => jumpBack$.next()}>go back</a> to your
          previous location.
        </div>
      </div>
    </div>
  )
}
